import { render, staticRenderFns } from "./moreDialog.vue?vue&type=template&id=63075471"
import script from "./moreDialog.vue?vue&type=script&lang=js"
export * from "./moreDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports